import { Component, computed, effect, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { CoreService } from '../../services'
import { groupsColumns } from '../../utils/definitions.util'
import { injectInfiniteQuery } from '@tanstack/angular-query-experimental'
import { UserGroupService } from '../../services/entity-services/userGroup.service'

@Component({
  selector: 'app-usergroups',
  templateUrl: './usergroups.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserGroupsComponent extends BaseListing implements OnInit {
  private userGroupService = inject(UserGroupService)

  listingColumns = signal(groupsColumns)
  sortProp = signal('name')
  sortDir = signal<'asc' | 'desc'>('asc')

  readonly filters = signal({})
  readonly queryFilters = computed(() => ({ ...this.filters() }))

  readonly queryUserGroups = injectInfiniteQuery(() => ({
    queryKey: ['userGroups', { sortProp: this.sortProp(), sortDir: this.sortDir(), filters: this.queryFilters() }],
    queryFn: async ({ pageParam }) => {
      return await this.userGroupService
        .getUserGroups({
          page: pageParam,
          sort: this.sortProp(),
          direction: this.sortDir(),
          filters: this.queryFilters(),
        })
        .then(result => {
          this.saveViewSettings('userGroups', this.filters())
          return result
        })
    },
    initialPageParam: 1,
    getNextPageParam: result => {
      return Number(result?.paginator?.current) < Number(result?.paginator?.endPage)
        ? Number(result?.paginator?.current) + 1
        : undefined
    },
  }))

  totalItems = computed(() => this.queryUserGroups.data()?.pages?.[0]?.paginator?.totalCount ?? 0)

  constructor(protected core: CoreService) {
    super(core)
    effect(() => {
      this.queryUserGroups.data()
    })
  }

  ngOnInit() {
    this.filters.set(this.loadViewSettings('userGroups') || {})
    this.loadSorting('userGroups')
  }
}
